import * as z from "zod";

export { updateDisplayNameInputSchema } from "@dailywars/core/displayNameValidation";

export const updateEndTurnConfirmationInputSchema = z.object({
  enabled: z.boolean(),
});

export const updateFastAnimationsInputSchema = z.object({
  enabled: z.boolean(),
});
